import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import clientApi from '../../clientApi';
import logo from '../../assets/logo.png';

const labelStyle = { display: 'block', fontSize: '10px', letterSpacing: '1.5px', textTransform: 'uppercase', color: 'rgba(230,190,138,0.6)', fontWeight: '500', marginBottom: '8px' };
const inputStyle = {
  width: '100%', padding: '12px 14px',
  background: 'rgba(255,255,255,0.06)',
  border: '1px solid rgba(230,190,138,0.2)',
  borderRadius: '4px', color: 'var(--white)',
  fontFamily: 'Jost, sans-serif', fontSize: '14px'
};

const ClientLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await clientApi.post('/api/client/login', { email, password });
      localStorage.setItem('cw_client_token', res.data.token);
      localStorage.setItem('cw_client_customer', JSON.stringify(res.data.customer));
      navigate('/client');
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed. Please check your details.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: 'var(--navy)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' }}>
      <div style={{ width: '100%', maxWidth: '400px' }}>
        <div style={{ textAlign: 'center', marginBottom: '40px' }}>
          <img src={logo} alt="Crossman & Walsh" style={{ width: '120px', height: '120px', borderRadius: '8px', marginBottom: '20px' }} />
          <div style={{ color: 'var(--gold)', letterSpacing: '3px', fontSize: '11px', fontWeight: '500', textTransform: 'uppercase', marginBottom: '4px' }}>
            Crossman & Walsh
          </div>
          <div style={{ color: 'rgba(230,190,138,0.5)', fontFamily: 'Cormorant Garamond, serif', fontStyle: 'italic', fontSize: '16px' }}>
            Client Portal
          </div>
        </div>

        <div style={{ background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(230,190,138,0.2)', borderRadius: '8px', padding: '36px' }}>
          <h2 style={{ color: 'var(--white)', fontFamily: 'Cormorant Garamond, serif', fontSize: '26px', fontWeight: '400', marginBottom: '28px', textAlign: 'center' }}>
            Welcome Back
          </h2>

          {error && (
            <div style={{ background: 'rgba(155,58,58,0.15)', border: '1px solid rgba(155,58,58,0.3)', color: '#e08080', padding: '12px 16px', borderRadius: '4px', fontSize: '13px', marginBottom: '20px' }}>
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label style={labelStyle}>Email Address</label>
              <input type="email" value={email} onChange={e => setEmail(e.target.value)} required style={inputStyle} />
            </div>
            <div className="form-group">
              <label style={labelStyle}>Password</label>
              <input type="password" value={password} onChange={e => setPassword(e.target.value)} required style={inputStyle} />
            </div>
            <button
              type="submit"
              disabled={loading}
              style={{
                width: '100%', padding: '13px',
                background: 'var(--gold)', color: 'var(--navy)',
                border: 'none', borderRadius: '4px',
                fontFamily: 'Jost, sans-serif', fontSize: '12px',
                fontWeight: '600', letterSpacing: '2px',
                textTransform: 'uppercase', cursor: 'pointer',
                marginTop: '8px', opacity: loading ? 0.7 : 1
              }}
            >
              {loading ? 'Signing in...' : 'Sign In'}
            </button>
          </form>
        </div>

        <p style={{ textAlign: 'center', color: 'rgba(255,255,255,0.2)', fontSize: '11px', marginTop: '24px', letterSpacing: '0.5px' }}>
          Crossman & Walsh Luxury Homes Ltd
        </p>
      </div>
    </div>
  );
};

export default ClientLogin;
